import React from 'react'
import Header from '../../Components/Header'
import WireCapabilities from '../../Components/wireCapabilities'
import wire from "../../imagens/wires/wire.jpg"
import wire2 from "../../imagens/wires/wire2.jpg"
import wire5 from "../../imagens/wires/wire5.jpg"
import wire6 from "../../imagens/wires/wire6.jpg"
import wire7 from "../../imagens/wires/wire7.jpg"
import wire11 from "../../imagens/wires/wire11.jpg"
import wire12 from "../../imagens/wires/wire12.jpg"
import chicote7 from "../../imagens/wireModules/chicote7.png"
import chicote8 from "../../imagens/wireModules/chicote8.png"
import chicote9 from "../../imagens/wireModules/chicote9.png"
import chicote10 from "../../imagens/wireModules/chicote10.png"


const listaChicotes = [
    {
        img:wire
    },
    {
        img:wire2
    },
    {
        img:wire5
    },
    {
        img:wire6
    },
    {
        img:wire7
    },
    {
        img:wire11
    },
    {
        img:wire12
    },
    {
        img:chicote7
    },
    {
        img:chicote8
    },
    {
        img:chicote9
    },
    {
        img:chicote10
    },
]




function WirePage() {
    return (
        <div>
            <Header/>

            <WireCapabilities
                listaChicotes = {listaChicotes}
                />
        </div>
    )
}

export default WirePage